

























import { defineComponent, ref, Ref, toRefs } from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default defineComponent({
  props: formFieldProps,
  components: { CFormError },
  setup(props) {
    const { name } = toRefs(props)

    const make = ref<string>('')
    const model = ref<string>('')

    function onValue(v: Ref<any>) {
      if (!v.value) {
        make.value = ''
        model.value = ''
        return
      }

      make.value = v.value.make
      model.value = v.value.model
    }
    const { debouncedValueChanged, error } = useClassifiedForm(props, {
      onValue
    })

    function updateValues() {
      debouncedValueChanged(name.value, {
        make: make.value,
        model: model.value
      })
    }

    function handleMakeInput(text: string) {
      make.value = text
      updateValues()
    }
    function handleModelInput(text: string) {
      model.value = text
      updateValues()
    }

    return { error, handleModelInput, handleMakeInput, make, model }
  }
})
